/**
 * Branches Service
 * Handles all branch-related API calls
 */

import { apiService, ApiResponse } from './api.service';

/** Branch Interface */
export interface Branch {
  id: string;
  tenantId: string;
  name: string;
  code: string;
  address?: string;
  phone?: string;
  email?: string;
  manager?: string;
  isMain: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateBranchDto {
  name: string;
  code: string;
  address?: string;
  phone?: string;
  email?: string;
  manager?: string;
  isMain?: boolean;
  isActive?: boolean;
}

/** Branches Query Parameters */
export interface BranchesQuery {
  tenantId?: string;
  isActive?: boolean;
  search?: string;
}

class BranchesService {
  /** Get all branches */
  async getBranches(query?: BranchesQuery): Promise<ApiResponse<Branch[]>> {
    const params = new URLSearchParams();
    if (query?.tenantId) params.append('tenantId', query.tenantId);
    if (query?.isActive !== undefined) params.append('isActive', query.isActive.toString());
    if (query?.search) params.append('search', query.search);

    const qs = params.toString() ? `?${params.toString()}` : '';
    return apiService.get<Branch[]>(`/branches${qs}`);
  }

  /** Get single branch by ID */
  async getBranchById(id: string): Promise<ApiResponse<Branch>> {
    return apiService.get<Branch>(`/branches/${id}`);
  }

  /** Create a new branch in the active tenant */
  async createBranch(data: CreateBranchDto): Promise<ApiResponse<Branch>> {
    return apiService.post<Branch>('/branches', data);
  }
}

export const branchesService = new BranchesService();
